import { ApiParams } from '@/api/helpers/apiHelpers';
import { ApiResponseType, ListResponseType } from '@/types/sharedTypes';
import { OrganizationUserType } from '@/bundle/_Opco/types/types';
import { authApiService } from '@/api/authApiService';

export const getOrganizationUsersApi = async (
  organizationId: string,
  params?: ApiParams
): Promise<ApiResponseType<ListResponseType<OrganizationUserType>>> => {
  const uri = `/opco/organizations/${organizationId}/users/`;

  return authApiService.GET(uri, params);
};
